(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('companies-statistics', {
            parent: 'admin',
            url: '/companies-statistics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'companies.statistics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/statistics/companies-statistics.html',
                    controller: 'CompaniesStatisticsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statistics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
